export const dataTestIds = {
	includeChildLevelIssuesToggle:
		'software-board-settings-timeline.ui.timeline-settings-page.enable-timeline.include-child-level-issues.toggle',
	includeChildLevelIssuesRadioGroup:
		'software-board-settings-timeline.ui.timeline-settings-page.enable-timeline.include-child-level-issues.radio-group',
	enableTimelineToggle:
		'software-board-settings-timeline.ui.timeline-settings-page.enable-timeline.toggle',
} as const;
